import React from 'react';
import { LuCheck, LuX, LuTriangleAlert , LuInfo } from 'react-icons/lu';
import '../styles/Toast.css';

const ICONS = {
  success: <LuCheck />,
  error: <LuX />,
  warning: <LuTriangleAlert  />,
  info: <LuInfo />,
};

const Toast = ({ toast, onRemove }) => (
  <div className={`toast toast-${toast.type}`} role="alert" aria-live="assertive">
    <span className="toast-icon">{ICONS[toast.type]}</span>
    <span className="toast-message">{toast.message}</span>
    <button
      className="toast-close"
      onClick={() => onRemove(toast.id)}
      aria-label="Cerrar notificación"
    >
      <LuX />
    </button>
  </div>
);

const ToastContainer = ({ toasts, onRemove }) => {
  if (toasts.length === 0) return null;
  return (
    <div className="toast-container" role="region" aria-label="Notificaciones">
      {toasts.map(t => (
        <Toast key={t.id} toast={t} onRemove={onRemove} />
      ))}
    </div>
  );
};

export default ToastContainer;
